import React from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import UserLayout from '../../screens/userDashboard/userLayout';

function UserDashboardRoutes({ component: Component, ...restOfProps }) {
  const { userIdentityToken, uuid, location } = restOfProps;
  const isAuthenticated = userIdentityToken && uuid;
  const { pathname } = location;
  let redirectRoute = '/';
  if (!userIdentityToken || !uuid) redirectRoute = `/sign-in?redirectTo=${pathname}`;
  if (!isAuthenticated) return <Redirect to={redirectRoute} />;

  return (
    <Route
      {...restOfProps}
      render={(props) => (
        <UserLayout>
          <Component {...props} />
        </UserLayout>
      )}
    />
  );
}

export default withRouter(UserDashboardRoutes);
